module.exports = __webpack_public_path__ + "img/ferasse-hivert-barthe.8de47db8.jpg";